module.exports = __webpack_public_path__ + "static/media/close.46a6eb73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.svg
// module id = 626
// module chunks = 1